var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12C7.27477 11.5415 6 9.92447 6 8C6 6.07553 7.27477 4.45849 9 4",
    stroke: "#4F4C60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 12C16.8363 11.5415 18.1111 9.92447 18.1111 8C18.1111 6.07553 16.8363 4.45849 15.1111 4",
    stroke: "#4F4C60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11111 15H7.63379C7.26241 15 7.07673 15 6.91351 15.0134C5.22373 15.152 3.80489 16.3408 3.37266 17.9803C3.33091 18.1386 3.29841 18.3214 3.23341 18.6871V18.6871C3.21108 18.8127 3.19992 18.8755 3.19615 18.9266C3.15645 19.4661 3.55301 19.9394 4.09115 19.9948C4.14217 20 4.20595 20 4.3335 20H9",
    stroke: "#4F4C60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H16.4773C16.8487 15 17.0344 15 17.1976 15.0134C18.8874 15.152 20.3062 16.3408 20.7384 17.9803C20.7802 18.1386 20.8127 18.3214 20.8777 18.6871V18.6871C20.9 18.8127 20.9112 18.8755 20.9149 18.9266C20.9546 19.4661 20.5581 19.9394 20.0199 19.9948C19.9689 20 19.9051 20 19.7776 20H15.1111",
    stroke: "#4F4C60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2L12 22",
    stroke: "#4F4C60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.0577135d2146d391652dda98415e3c02.svg";
export { ForwardRef as ReactComponent };